import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastStack } from '../ui/ToastStack';
import { selectToasts, toastDismissed } from '../../features/feedback/feedbackSlice';
import { TOAST_ACTION } from '../../features/feedback/feedbackConstants';
import { activityPanelOpened } from '../../features/notifications/notificationsSlice';

/**
 * The toast stack, wired to the store. Mounted once by each shell — `AppShell`,
 * `OperatorLayout` — so a message outlives the page that raised it.
 *
 * @param {object} props
 * @param {'bottom'|'aboveActionBar'} [props.placement] - See `ToastStack`.
 */
export const FeedbackHost = ({ placement }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toasts = useSelector(selectToasts);

  const dismiss = useCallback((id) => dispatch(toastDismissed(id)), [dispatch]);

  const act = useCallback(
    (toast) => {
      const { action } = toast;
      if (action.type === TOAST_ACTION.NAVIGATE) navigate(action.to);
      if (action.type === TOAST_ACTION.OPEN_ACTIVITY) dispatch(activityPanelOpened());
      // Opened here, inside the click, so a popup blocker lets it through.
      if (action.type === TOAST_ACTION.OPEN_URL) window.open(action.url, '_blank', 'noopener,noreferrer');
      dismiss(toast.id);
    },
    [dispatch, navigate, dismiss]
  );

  return <ToastStack toasts={toasts} onDismiss={dismiss} onAction={act} placement={placement} />;
};
